export const _cnpj = (value = '') => {
    let exp = value.replace(/\d/g, "");
    if (exp !=='') {
        return false;
    }
    return true;
}

export const getCnpj = value => value.replace(/[^\d]/g, "");